import { OutlinedInput } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

export default withStyles(styles)(OutlinedInput);
